import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Ota from 'frontend-utils/models/ota';
import type Roomtype from 'frontend-utils/models/roomtype';
import { OTA_IDS } from 'frontend-utils/utils/constants/constant-values';
import type HotelSettingsCentralMappingChannelRoomCategoriesRoute from 'lumen/routes/hotel/settings/central-mapping/channel-room-categories';
import { CHANNEL_ROOM_MAPPING_PRODUCTS } from 'lumen/utils/central-mapping-constants';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCentralMappingChannelRoomCategoriesController extends Controller {
  declare model: ModelFrom<HotelSettingsCentralMappingChannelRoomCategoriesRoute>;
  queryParams = ['ota'];
  @service declare access: Services['access'];
  @service declare store: Services['store'];

  @tracked ota = '';

  get canSelectOTA(): boolean {
    return this.access.hasRates || this.access.hasPricingAssistantTab;
  }

  get dataType(): (typeof CHANNEL_ROOM_MAPPING_PRODUCTS)[keyof typeof CHANNEL_ROOM_MAPPING_PRODUCTS] {
    if (this.ota === OTA_IDS.ALL_CHANNELS) {
      return CHANNEL_ROOM_MAPPING_PRODUCTS.PARITY;
    }
    return CHANNEL_ROOM_MAPPING_PRODUCTS.ALL_PRODUCTS;
  }

  get isRatePreferenceLoading(): boolean {
    return Boolean(this.model.ratePreferenceTaskResult?.isRunning);
  }

  get isRoomtypeRequestLoading(): boolean {
    return Boolean(this.model.roomtypes.isRunning);
  }

  get roomtypes(): Roomtype[] | null | undefined {
    return this.model.roomtypes.value;
  }

  get selectedOTA(): Ota | null {
    return this.store.peekRecord<Ota>('ota', this.ota);
  }

  @action chooseOTA(ota: Ota): void {
    this.ota = ota.id as string;
  }

  @action doRefresh(): void {
    this.send('refreshRoute');
  }
}
